<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium (Padrão Sistema) -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3 bg-white border-bottom">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%);">
            <i class="fa fa-dashboard text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold text-dark">Dashboard de Produção</h4>
            <small class="text-muted mb-0 d-none d-lg-block">Análise Mensal de Performance e Custos</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
          <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
            <div class="d-flex align-items-center px-3 border-right mr-2">
              <label class="mb-0 mr-2 small text-muted font-weight-bold">MÊS:</label>
              <b-form-select v-model="filtro.mes" :options="meses" class="bg-transparent border-0 p-0 font-weight-bold" :style="{ width: '110px', fontSize: '0.85rem' }" @change="carregarDashboard"></b-form-select>
            </div>
            <div class="d-flex align-items-center px-3">
              <label class="mb-0 mr-2 small text-muted font-weight-bold">ANO:</label>
              <b-form-select v-model="filtro.ano" :options="anos" class="bg-transparent border-0 p-0 font-weight-bold" :style="{ width: '80px', fontSize: '0.85rem' }" @change="carregarDashboard"></b-form-select>
            </div>
          </div>
          
          <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" @click="carregarDashboard">
            <i class="fa fa-refresh mr-1"></i> ATUALIZAR
          </b-button>
        </div>
      </div>

      <!-- Resumo Analítico (Cards Padrão Sistema) -->
      <b-row class="mb-3 px-2">
        <b-col md="3" sm="6" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg h-100 border-left-primary">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="text-muted mb-1 text-uppercase small font-weight-bold">Produzido (KG)</p>
                  <h4 class="text-dark mb-0 font-weight-bold">{{ totais.TOTAL_KG | formatarNumero }}</h4>
                </div>
                <div class="icon-circle bg-primary-soft">
                  <i class="fa fa-weight-hanging text-primary"></i>
                </div>
              </div>
              <div class="mt-2">
                <small class="text-muted"><i class="fa fa-boxes mr-1"></i> {{ totais.TOTAL_PECAS | formatarInteiro }} Peças</small>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="3" sm="6" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg h-100 border-left-info">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="text-muted mb-1 text-uppercase small font-weight-bold">Apontamentos</p>
                  <h4 class="text-dark mb-0 font-weight-bold">{{ totais.TOTAL_APONTAMENTOS | formatarInteiro }}</h4>
                </div>
                <div class="icon-circle bg-info-soft">
                  <i class="fa fa-clipboard-check text-info"></i>
                </div>
              </div>
              <div class="mt-2">
                <small class="text-muted"><i class="fa fa-calendar mr-1"></i> Neste mês</small>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="3" sm="6" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg h-100 border-left-success">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="text-muted mb-1 text-uppercase small font-weight-bold">Custo Total (R$)</p>
                  <h4 class="text-dark mb-0 font-weight-bold">{{ totais.TOTAL_CUSTO | formatarMoeda }}</h4>
                </div>
                <div class="icon-circle bg-success-soft">
                  <i class="fa fa-money text-success"></i>
                </div>
              </div>
              <div class="mt-2">
                <small class="text-muted"><i class="fa fa-calculator mr-1"></i> Custo de Insumos</small>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="3" sm="6" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg h-100 border-left-warning">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <p class="text-muted mb-1 text-uppercase small font-weight-bold">Custo Médio / KG</p>
                  <h4 class="text-dark mb-0 font-weight-bold">{{ calcularCustoMedio() | formatarMoeda }}</h4>
                </div>
                <div class="icon-circle bg-warning-soft">
                  <i class="fa fa-line-chart text-warning"></i>
                </div>
              </div>
              <div class="mt-2">
                <small class="text-muted"><i class="fa fa-info-circle mr-1"></i> Valor por Quilo</small>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- Gráficos -->
      <b-row class="mb-4 px-2">
        <b-col lg="8" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg h-100">
            <div class="card-header bg-white border-bottom-0 pt-3 d-flex justify-content-between align-items-center">
              <h6 class="m-0 font-weight-bold text-dark">Produção Diária (KG)</h6>
              <div v-if="diaSelecionado">
                <b-badge variant="success" class="rounded-pill px-3 py-2">Dia {{ diaSelecionado }} Selecionado</b-badge>
                <b-button variant="link" size="sm" class="text-muted ml-2" @click="selecionarDia(null)">Limpar</b-button>
              </div>
            </div>
            <div class="card-body">
              <div class="chart-container" style="height: 250px;">
                <producao-mensal-chart 
                  :data="chartDiaria.dados" 
                  :labels="chartDiaria.labels" 
                  height="250"
                  @day-selected="selecionarDia"
                />
              </div>
            </div>
          </div>
        </b-col>
        <b-col lg="4" class="mb-3">
          <div class="card border-0 shadow-sm rounded-lg h-100">
            <div class="card-header bg-white border-bottom-0 pt-3">
              <h6 class="m-0 font-weight-bold text-dark">Mix de Produtos</h6>
            </div>
            <div class="card-body">
              <div class="chart-container" style="height: 250px;">
                <producao-produto-chart 
                  :data="chartProdutos.dados" 
                  :labels="chartProdutos.labels" 
                  height="250"
                />
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- Listagem Detalhada -->
      <b-row class="px-2">
        <b-col cols="12">
          <div class="card border-0 shadow-sm rounded-lg overflow-hidden">
            <div class="card-header bg-white border-bottom-0 pt-3">
              <h6 class="m-0 font-weight-bold text-dark">
                {{ diaSelecionado ? 'Detalhamento do Dia ' + diaSelecionado : 'Últimos Apontamentos do Mês' }}
              </h6>
            </div>
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table table-hover mb-0" style="font-size: 0.85rem;">
                  <thead class="bg-light text-muted uppercase small">
                    <tr>
                      <th class="border-0">ID</th>
                      <th class="border-0">DATA/HORA</th>
                      <th class="border-0">PRODUTO</th>
                      <th class="border-0">FÓRMULA</th>
                      <th class="border-0 text-center">LOTE</th>
                      <th class="border-0 text-right">QUANT. (KG)</th>
                      <th class="border-0">USUÁRIO</th>
                      <th class="border-0 text-center">AÇÕES</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in apontamentos" :key="item.ID">
                      <td class="align-middle">#{{ item.ID }}</td>
                      <td class="align-middle text-muted">{{ formatarData(item.DATA_APONTAMENTO) }}</td>
                      <td class="align-middle font-weight-bold text-dark">{{ item.PRODUTO_NOME }}</td>
                      <td class="align-middle small">{{ item.FORMULA_NOME }}</td>
                      <td class="align-middle text-center"><b-badge variant="light" pill>{{ item.LOTE }}</b-badge></td>
                      <td class="align-middle text-right font-weight-bold">{{ item.QUANT_PRODUZIDA | formatarNumero }}</td>
                      <td class="align-middle small text-muted">{{ item.USUARIO_CADASTRO }}</td>
                      <td class="align-middle text-center">
                        <b-button variant="link" size="sm" @click="abrirApontamento(item)">
                          <i class="fa fa-search"></i>
                        </b-button>
                      </td>
                    </tr>
                    <tr v-if="!apontamentos.length">
                      <td colspan="8" class="text-center py-4 text-muted">Nenhum apontamento encontrado para este período</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import ProducaoMensalChart from './ProducaoMensalChart'
import ProducaoProdutoChart from './ProducaoProdutoChart'

export default {
  name: 'ProducaoDashboard',
  components: {
    ProducaoMensalChart,
    ProducaoProdutoChart
  },
  data () {
    return {
      filtro: {
        mes: dayjs().month() + 1,
        ano: dayjs().year()
      },
      diaSelecionado: null,
      totais: {
        TOTAL_KG: 0,
        TOTAL_PECAS: 0,
        TOTAL_APONTAMENTOS: 0,
        TOTAL_PERDA_KG: 0,
        TOTAL_SOBRA_KG: 0,
        TOTAL_CUSTO: 0
      },
      chartDiaria: { labels: [], dados: [] },
      chartProdutos: { labels: [], dados: [] },
      apontamentos: [],
      meses: [
        { value: 1, text: 'Janeiro' }, { value: 2, text: 'Fevereiro' }, { value: 3, text: 'Março' },
        { value: 4, text: 'Abril' }, { value: 5, text: 'Maio' }, { value: 6, text: 'Junho' },
        { value: 7, text: 'Julho' }, { value: 8, text: 'Agosto' }, { value: 9, text: 'Setembro' },
        { value: 10, text: 'Outubro' }, { value: 11, text: 'Novembro' }, { value: 12, text: 'Dezembro' }
      ]
    }
  },
  computed: {
    anos () {
      const anoAtual = dayjs().year()
      const anos = []
      for (let i = anoAtual; i >= anoAtual - 5; i--) { anos.push(i) }
      return anos
    }
  },
  filters: {
    formatarNumero (valor) {
      if (!valor) return '0,00'
      return Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatarMoeda (valor) {
      if (!valor) return 'R$ 0,00'
      return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatarInteiro (valor) {
      if (!valor) return '0'
      return Number(valor).toLocaleString('pt-BR', { maximumFractionDigits: 0 })
    }
  },
  methods: {
    async carregarDashboard () {
      try {
        const { data } = await this.$http.get('api/protected/producao/formula/dashboard/resumo', {
          params: { mes: this.filtro.mes, ano: this.filtro.ano }
        })

        this.chartDiaria.labels = data.producaoDiaria.map(i => i.DIA)
        this.chartDiaria.dados = data.producaoDiaria.map(i => i.TOTAL_KG)
        this.chartProdutos.labels = data.producaoProdutos.map(i => i.PRODUTO_NOME)
        this.chartProdutos.dados = data.producaoProdutos.map(i => i.TOTAL_KG)
        this.totais = data.totais
        await this.carregarDetalhes()
      } catch (error) {
        this.$tools.logErroAuto(error, 'Erro ao carregar dashboard')
      }
    },
    async carregarDetalhes () {
      try {
        const { data } = await this.$http.get('api/protected/producao/formula/dashboard/detalhe', {
          params: { mes: this.filtro.mes, ano: this.filtro.ano, dia: this.diaSelecionado }
        })
        this.apontamentos = data
      } catch (error) {
        console.error(error)
      }
    },
    calcularCustoMedio () {
      if (!this.totais.TOTAL_KG || this.totais.TOTAL_KG === 0) return 0
      return (this.totais.TOTAL_CUSTO || 0) / this.totais.TOTAL_KG
    },
    selecionarDia (dia) {
      this.diaSelecionado = dia
      this.carregarDetalhes()
    },
    formatarData (data) {
      return dayjs(data).format('DD/MM/YYYY HH:mm')
    },
    abrirApontamento (item) {
      console.log('[Dashboard] Abrindo apontamento do processo:', item.PRD_FORM_PROC_ID)
      this.$router.push(`/producao/formula-processo/apontamento/${item.PRD_FORM_PROC_ID}`)
    }
  },
  mounted () {
    this.carregarDashboard()
  }
}
</script>

<style scoped>
.page-col { padding: 15px; background-color: #f4f7f6; min-height: 100vh; }
.shadow-xs { box-shadow: 0 2px 4px rgba(0,0,0,0.02) !important; }

/* KPI Circles */
.icon-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
}
.bg-primary-soft { background-color: rgba(33, 147, 176, 0.1); }
.bg-info-soft { background-color: rgba(29, 151, 108, 0.1); }
.bg-success-soft { background-color: rgba(40, 167, 69, 0.1); }
.bg-warning-soft { background-color: rgba(255, 193, 7, 0.1); }

/* Borders for Cards */
.border-left-primary { border-left: 4px solid #2193b0 !important; }
.border-left-info { border-left: 4px solid #1d976c !important; }
.border-left-success { border-left: 4px solid #28a745 !important; }
.border-left-warning { border-left: 4px solid #ffc107 !important; }

.rounded-lg { border-radius: 12px !important; }
.uppercase { text-transform: uppercase; }

.table thead th {
  padding: 12px;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #eee;
}
.table tbody td { padding: 12px; border-top: 1px solid #f8f9fa; }

.chart-container { position: relative; margin: auto; }
</style>



// WEBPACK FOOTER //
// src/views/producao/producao-dashboard/ProducaoDashboard.vue